import React, { useRef, useState } from "react";
import { ZoomIn } from "lucide-react";
import { Badges } from "../../components/ProductCard";

export const Gallery = ({ product }) => {
  const images = [product.image, ...(product.images || [])].filter(Boolean);
  const [idx, setIdx] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const img = useRef(null);
  const onMove = (e) => {
    const el = img.current; if (!el) return;
    const r = e.currentTarget.getBoundingClientRect();
    el.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
  };
  return (
    <div data-testid="product-gallery">
      <div className="relative bg-[#08090C] rounded-2xl border border-[#1E232D] overflow-hidden group cursor-zoom-in" onMouseEnter={() => setZoom(true)} onMouseLeave={() => setZoom(false)} onMouseMove={onMove} onClick={() => setZoom((z) => !z)} data-testid="product-gallery-main">
        <Badges product={product} />
        {!loaded && <div className="absolute inset-0 shimmer" />}
        <img ref={img} src={images[idx]} alt={product.name} onLoad={() => setLoaded(true)} className={`zoom-img w-full h-[360px] md:h-[480px] object-cover ${zoom ? "scale-[1.8]" : "scale-100"} ${loaded ? "opacity-100" : "opacity-0"}`} />
        <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 text-[11px] font-semibold text-slate-200 bg-black/60 backdrop-blur px-2 py-1 rounded-md pointer-events-none"><ZoomIn size={12} /> {zoom ? "Déplacez pour zoomer" : "Survolez pour zoomer"}</span>
      </div>
      {images.length > 1 && (
        <div className="flex gap-2 mt-3">
          {images.map((src, i) => (
            <button key={i} data-testid={`product-thumb-${i}`} onClick={() => { setIdx(i); setLoaded(false); }} className={`w-16 h-16 rounded-lg overflow-hidden border-2 transition-colors ${i === idx ? "border-[#E01F1F]" : "border-[#222735] hover:border-slate-500"}`}><img src={src} alt="" className="w-full h-full object-cover" /></button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Gallery;
